import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { deleteSaga } from "src/request/delete";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { putSaga } from "src/request/put";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import * as Type from "./type";

export const getCalllogStatusListSaga = createAction(
  "GET_CALL_LOG_STATUS",
  ({ payload, params }: SagaActionParams<Type.CalllogStatusDto[]>) => ({
    payload,
    url: "/api/admin/adminclientcalllogstatuses" + (params ? params : ""),
  })
);
export const getCalllogStatusDetailsSaga = createAction(
  "GET_CALL_LOG_STATUS_DETAILS",
  ({ payload, id }: SagaActionParams<Type.CalllogStatusDetailDto>) => ({
    payload,
    url: "/api/admin/adminclientcalllogstatuses/" + id,
  })
);
export const createCalllogStatusSaga = createAction(
  "CREATE_CALL_LOG_STATUS",
  ({ payload, body }: SagaActionParams<Type.CalllogStatusDto>) => ({
    payload,
    url: "/api/admin/adminclientcalllogstatuses",
    body,
  })
);
export const updateCalllogStatusSaga = createAction(
  "UPDATE_CALL_LOG_STATUS",
  ({ payload, id, body }: SagaActionParams<Type.CalllogStatusDto>) => ({
    payload,
    url: "/api/admin/adminclientcalllogstatuses/" + id,
    body,
  })
);
export const deleteCalllogStatusSaga = createAction(
  "DELETE_CALL_LOG_STATUS",
  ({ payload, id }: SagaActionParams<Type.CalllogStatusDto>) => ({
    payload,
    url: "/api/admin/adminclientcalllogstatuses/" + id,
  })
);

const calllogstatusSaga = [
  takeLatest<any>(
    getCalllogStatusListSaga.toString(),
    (payload: SagaGenericParams<Type.CalllogStatusDto[]>) =>
      getSaga<Type.CalllogStatusDto[]>(payload)
  ),
  takeLatest<any>(
    getCalllogStatusDetailsSaga.toString(),
    (payload: SagaGenericParams<Type.CalllogStatusDetailDto>) =>
      getSaga<Type.CalllogStatusDetailDto>(payload)
  ),
  takeLatest<any>(
    createCalllogStatusSaga.toString(),
    (payload: SagaGenericParams<Type.CalllogStatusDto>) =>
      postSaga<Type.CalllogStatusDto>(payload)
  ),
  takeLatest<any>(
    updateCalllogStatusSaga.toString(),
    (payload: SagaGenericParams<Type.CalllogStatusDto>) =>
      putSaga<Type.CalllogStatusDto>(payload)
  ),
  takeLatest<any>(
    deleteCalllogStatusSaga.toString(),
    (payload: SagaGenericParams<any>) =>
      deleteSaga<Type.CalllogStatusDto>(payload)
  ),
];

export default calllogstatusSaga;
